import { pxToRem } from "styled-media-query";

const breakpoints = pxToRem({
  mobile: "768px",
  ipad: "1024px",
  ipadPro: "1025px",
  desktop: "1250px",
  large: "1920px",
});

export default breakpoints;
